import styled, { css } from 'styled-components'
import { Modal } from 'antd'


export const ModalAlert = styled(Modal)`
    font-size: 24px;
`

export default ModalAlert



// WEBPACK FOOTER //
// ./src/components/common/modal/styled.js